export const PLATFORM_PARTNER_ID = 0;
